<template>
  <div
    class="modal fade ag-modal ag-partner-modal"
    id="agPartnerModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ag-modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 v-if="!partnerFormValues.id">Create New Partner</h3>
          <h3 v-if="partnerFormValues.id">Edit Partner</h3>
        </div>
        <Form
          @submit="onSubmit"
          autocomplete="off"
          ref="form"
          :key="compKey"
          :validation-schema="schema"
          :initial-values="partnerFormValues"
          v-slot="{ meta }"
        >
          <input
            autocomplete="false"
            name="hidden"
            type="text"
            style="display: none"
          />
          <div class="modal-body">
            <div class="ag-modal-form w-100">
              <ul class="ag-modal-form-list">
                <li>
                  <span class="bold-text">Name : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="name" v-slot="{ field, meta }">
                        <input
                          type="text"
                          name="name"
                          maxlength="191"
                          v-model="partnerFormValues.name"
                          class="form-control"
                          placeholder="Enter Name"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="name"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li>
                  <span class="bold-text">Short Name : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="shortName" v-slot="{ field, meta }">
                        <input
                          type="text"
                          name="shortName"
                          maxlength="191"
                          v-model="partnerFormValues.shortName"
                          class="form-control"
                          placeholder="Enter Short Name"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="shortName"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li>
                  <span class="bold-text">Contact Name : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="contactName" v-slot="{ field, meta }">
                        <input
                          type="text"
                          name="contactName"
                          maxlength="191"
                          v-model="partnerFormValues.contactName"
                          class="form-control"
                          placeholder="Enter Contact Name"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="contactName"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li>
                  <span class="bold-text">Contact Phone : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="contactPhone" v-slot="{ field, meta }">
                        <vue-tel-input
                          maxlength="191"
                          v-model="partnerFormValues.contactPhone"
                          class="form-control"
                          v-bind="field"
                          type="number"
                          @input="onChangePhone"
                          @keypress="isNumber($event)"
                          :input-options="{
                            name: 'contactPhone',
                            placeholder: 'Enter Contact Phone',
                            showDialCode: true,
                            required: true,
                            type: 'tel',
                          }"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        >
                        </vue-tel-input>
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="contactPhone"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li>
                  <span class="bold-text">E-Mail : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="contactEmail" v-slot="{ field, meta }">
                        <input
                          type="email"
                          name="contactEmail"
                          maxlength="191"
                          autoComplete="new-email"
                          v-model="partnerFormValues.contactEmail"
                          class="form-control"
                          placeholder="Enter Your E-Mail"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="contactEmail"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              :disabled="!meta.valid || loading"
              class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_primary float-inline-end"
            >
              Save
            </button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { useStore } from "@/store";
import { notify } from "@kyvg/vue3-notification";
import { Roles } from "@/helpers/enums/Roles";
import apiAGSC from "@/store/axiosAgsc";
import { Field, Form, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { GeneralActionTypes } from "@/store/modules/general/action-types";

const store = useStore();
const phoneRegExp =
  /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*(\d{1,2})$/;

export default {
  name: "ag-partner-modal",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  props: {
    selectedPartner: {},
    module: {},
  },
  data() {
    const schema = Yup.object().shape({
      name: Yup.string().required().label("Name"),
      shortName: Yup.string().required().label("Short Name"),
      contactName: Yup.string().required().label("Contact Name"),
      contactPhone: Yup.string()
        .matches(phoneRegExp, "Phone number is not valid")
        .required()
        .label("Contact Phone"),
      contactEmail: Yup.string().email().required().label("Contact Email"),
    });
    return {
      schema,
      loading: false,
      Roles: Roles,
      contactPhone: "",
      partnerFormValues: {
        name: "",
        shortName: "",
        contactName: "",
        contactPhone: "",
        contactEmail: "",
      },
    };
  },
  watch: {
    selectedPartner() {
      if (this.selectedPartner && this.selectedPartner.id) {
        this.$refs.form.resetForm();
        this.partnerFormValues = this.selectedPartner;
      }
    },
    compKey() {
      this.partnerFormValues = {
        name: "",
        shortName: "",
        contactName: "",
        contactPhone: "",
        contactEmail: "",
      };
    },
  },
  computed: {
    ...mapGetters(["loggedInUser"]),
    company() {
      return store.getters.company;
    },
    compKey() {
      return store.getters.compKey;
    },
  },
  methods: {
    onChangePhone(val) {
      if (typeof val === 'string' || val instanceof String) {
        this.partnerFormValues.contactPhone = val;
      }
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      
      if ( (charCode < 48 || charCode > 57) && charCode !== 43) {
        evt.preventDefault();;
      }
      else {
        return true;
      }
    },
    async onSubmit() {
      this.loading = true;
      const body = this.partnerFormValues;
      let request = "post";
      if (this.partnerFormValues.id) {
        // request = "put";
      }
      apiAGSC[request]("Partner/CreateOrEdit", body)
        .then((res) => {
          let errors = [];
          if (res.data.status && res.data.status !== 200 && res.data.errors) {
            errors = res.data.errors;
          } else if (
            res.data.Status &&
            res.data.Status !== 200 &&
            res.data.Errors
          ) {
            errors = res.data.Errors;
          } else if (
            res.data.statusCode &&
            res.data.statusCode !== 200 &&
            res.data.errors
          ) {
            errors = res.data.errors;
          } else if (
            (res.data.statusCode && res.data.statusCode !== 200) ||
            (res.data.status && res.data.status !== 200 && res.data.Message)
          ) {
            errors = [res.data.Message];
          }
          if (errors.length > 0) {
            const errorMessage = errors.map((f) => "<li>" + f + "</li>");
            notify({
              title: "An Error Occurred..",
              type: "error",
              text:
                "<p>" +
                res.data.Message +
                "</p>" +
                "<ul>" +
                errorMessage +
                "</ul>",
              duration: 8000,
            });
          } else {
            this.closeAllModals();
            notify({
              title: this.partnerFormValues.id
                ? "Partner successfully updated"
                : "Partner added successfully",
              type: "success",
              duration: 4000,
            });
            store.dispatch(
              GeneralActionTypes.SET_COMPKEY,
              store.getters.compKey + 1
            );
            store.dispatch(GeneralActionTypes.GET_PARTNERS, {
              options: {
                sortable: this.module.component.options.sortable,
                isLoading: true,
                total: 0,
                page: this.module.component.options.page,
                pageSize: this.module.component.options.pageSize,
              },
              filters: {
                limit: 10,
              },
            });
          }
        })
        .catch((e) => {
          console.log(e);
          if (e && e.errors) {
            const errors = e.errors.map((f) => "<li>" + f + "</li>");
            notify({
              title: "An Error Occurred..",
              type: "error",
              text: "<p>" + e.message + "</p>" + "<ul>" + errors + "</ul>",
              duration: 8000,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeAllModals() {
      const modals = document.getElementsByClassName("modal");

      for (let i = 0; i < modals.length; i++) {
        modals[i].classList.remove("show");
        modals[i].setAttribute("aria-hidden", "true");
        modals[i].setAttribute("style", "display: none");
      }

      const modalsBackdrops = document.getElementsByClassName("modal-backdrop");

      for (let i = 0; i < modalsBackdrops.length; i++) {
        document.body.removeChild(modalsBackdrops[i]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-modal .modal-body label {
  color: #8e8e8e;
  font-size: 14px;
  margin: 0;
  display: flex;
  align-items: center;
}

.ag-modal-form-list {
  margin-left: 30px;
}

.ag-modal .modal-body label input {
  margin-right: 4px;
}

.ag-modal-form-list li {
  width: 86%;
}

.ag-modal-form-list li .bold-text {
  text-align: left !important;
  width: 33% !important;
}

.error-wrapper {
  display: block;
  width: 100%;
}
li.form-group-full {
  display: flex;
  flex-direction: column;
}

.position-relative {
  width: 100%;
  display: block;
}

.vue-tel-input
 {
  display: flex !important;
  border: 1px solid #bbb !important;
  text-align: left !important;
 }
</style>
